module.exports = {
	"1": {
		"name": "Австралия",
		"mask": "+61",
		"length": 9
	},
	"2": {
		"name": "Австрия",
		"mask": "+43",
		"length": 9
	},
	"3": {
		"name": "Азербайджан",
		"mask": "+994",
		"length": 9
	},
	"5": {
		"name": "Алжир",
		"mask": "+213",
		"length": 9
	},
	"6": {
		"name": "Американское Самоа",
		"mask": "+1",
		"length": 10
	},
	"7": {
		"name": "Ангилья",
		"mask": "+1",
		"length": 10
	},
	"8": {
		"name": "Ангола",
		"mask": "+244",
		"length": 9
	},
	"9": {
		"name": "Андорра",
		"mask": "+376",
		"length": 6
	},
	"11": {
		"name": "Антигуа и Барбуда",
		"mask": "+1",
		"length": 10
	},
	"12": {
		"name": "Аргентина",
		"mask": "+54",
		"length": 11
	},
	"13": {
		"name": "Армения",
		"mask": "+374",
		"length": 8
	},
	"14": {
		"name": "Аруба",
		"mask": "+297",
		"length": 7
	},
	"15": {
		"name": "Афганистан",
		"mask": "+93",
		"length": 9
	},
	"16": {
		"name": "Багамы",
		"mask": "+1",
		"length": 10
	},
	"17": {
		"name": "Бангладеш",
		"mask": "+880",
		"length": 10
	},
	"18": {
		"name": "Барбадос",
		"mask": "+1",
		"length": 10
	},
	"19": {
		"name": "Бахрейн",
		"mask": "+973",
		"length": 8
	},
	"20": {
		"name": "Белиз",
		"mask": "+501",
		"length": 7
	},
	"21": {
		"name": "Белоруссия",
		"mask": "+375",
		"length": 9
	},
	"22": {
		"name": "Бельгия",
		"mask": "+32",
		"length": 9
	},
	"23": {
		"name": "Бенин",
		"mask": "+229",
		"length": 8
	},
	"24": {
		"name": "Бермуды",
		"mask": "+1",
		"length": 10
	},
	"25": {
		"name": "Болгария",
		"mask": "+359",
		"length": 8
	},
	"26": {
		"name": "Боливия",
		"mask": "+571",
		"length": 8
	},
	"27": {
		"name": "Босния и Герцеговина",
		"mask": "+387",
		"length": 8
	},
	"28": {
		"name": "Ботсвана",
		"mask": "+267",
		"length": 8
	},
	"29": {
		"name": "Бразилия",
		"mask": "+55",
		"length": 10
	},
	"30": {
		"name": "Британская территория в Индийском океане",
		"mask": "+246",
		"length": 7
	},
	"32": {
		"name": "Бруней",
		"mask": "+673",
		"length": 7
	},
	"33": {
		"name": "Буркина Фасо",
		"mask": "+226",
		"length": 8
	},
	"34": {
		"name": "Бурунди",
		"mask": "+257",
		"length": 8
	},
	"35": {
		"name": "Бутан",
		"mask": "+975",
		"length": 8
	},
	"36": {
		"name": "Вануату",
		"mask": "+678",
		"length": 7
	},
	"38": {
		"name": "Великобритания",
		"mask": "+44",
		"length": 10
	},
	"39": {
		"name": "Венгрия",
		"mask": "+36",
		"length": 9
	},
	"40": {
		"name": "Венесуэла",
		"mask": "+58",
		"length": 10
	},
	"42": {
		"name": "Вьетнам",
		"mask": "+84",
		"length": 9
	},
	"43": {
		"name": "Габон",
		"mask": "+241",
		"length": 8
	},
	"44": {
		"name": "Гаити",
		"mask": "+509",
		"length": 8
	},
	"45": {
		"name": "Гайана",
		"mask": "+592",
		"length": 7
	},
	"46": {
		"name": "Гамбия",
		"mask": "+220",
		"length": 7
	},
	"47": {
		"name": "Гана",
		"mask": "+233",
		"length": 9
	},
	"48": {
		"name": "Гваделупа",
		"mask": "+590",
		"length": 9
	},
	"49": {
		"name": "Гватемала",
		"mask": "+502",
		"length": 8
	},
	"50": {
		"name": "Гвинея",
		"mask": "+224",
		"length": 8
	},
	"51": {
		"name": "Гвинея-Бисау",
		"mask": "+245",
		"length": 7
	},
	"52": {
		"name": "Германия",
		"mask": "+49",
		"length": 11
	},
	"53": {
		"name": "Гондурас",
		"mask": "+504",
		"length": 8
	},
	"54": {
		"name": "Государство Палестина",
		"mask": "+970",
		"length": 9
	},
	"55": {
		"name": "Гренада",
		"mask": "+1",
		"length": 10
	},
	"56": {
		"name": "Гренландия",
		"mask": "+299",
		"length": 6
	},
	"58": {
		"name": "Гуам",
		"mask": "+1",
		"length": 10
	},
	"60": {
		"name": "Джибути",
		"mask": "+253",
		"length": 8
	},
	"61": {
		"name": "Доминика",
		"mask": "+1",
		"length": 10
	},
	"62": {
		"name": "Доминиканская Республика",
		"mask": "+1",
		"length": 10
	},
	"63": {
		"name": "Египет",
		"mask": "+20",
		"length": 10
	},
	"64": {
		"name": "Замбия",
		"mask": "+260",
		"length": 9
	},
	"65": {
		"name": "Западная Сахара",
		"mask": "+212",
		"length": 9
	},
	"66": {
		"name": "Зимбабве",
		"mask": "+263",
		"length": 9
	},
	"67": {
		"name": "Израиль",
		"mask": "+972",
		"length": 9
	},
	"68": {
		"name": "Индия",
		"mask": "+91",
		"length": 10
	},
	"69": {
		"name": "Индонезия",
		"mask": "+62",
		"length": 9
	},
	"70": {
		"name": "Иордания",
		"mask": "+962",
		"length": 9
	},
	"71": {
		"name": "Ирак",
		"mask": "+964",
		"length": 10
	},
	"72": {
		"name": "Иран",
		"mask": "+98",
		"length": 10
	},
	"73": {
		"name": "Ирландия",
		"mask": "+353",
		"length": 9
	},
	"74": {
		"name": "Исландия",
		"mask": "+354",
		"length": 7
	},
	"75": {
		"name": "Испания",
		"mask": "+34",
		"length": 9
	},
	"76": {
		"name": "Италия",
		"mask": "+39",
		"length": 10
	},
	"77": {
		"name": "Йемен",
		"mask": "+967",
		"length": 9
	},
	"78": {
		"name": "Кабо-Верде",
		"mask": "+238",
		"length": 7
	},
	"79": {
		"name": "Казахстан",
		"mask": "+7",
		"length": 10
	},
	"80": {
		"name": "Каймановы острова",
		"mask": "+1",
		"length": 10
	},
	"81": {
		"name": "Камбоджа",
		"mask": "+855",
		"length": 8
	},
	"82": {
		"name": "Камерун",
		"mask": "+237",
		"length": 8
	},
	"83": {
		"name": "Канада",
		"mask": "+1",
		"length": 10
	},
	"84": {
		"name": "Катар",
		"mask": "+974",
		"length": 8
	},
	"85": {
		"name": "Кения",
		"mask": "+254",
		"length": 9
	},
	"86": {
		"name": "Кирибати",
		"mask": "+686",
		"length": 5
	},
	"87": {
		"name": "Китайская Республика",
		"mask": "+886",
		"length": 9
	},
	"88": {
		"name": "Korea, Democratic People's Republic of",
		"mask": "+850",
		"length": 10
	},
	"89": {
		"name": "Кокосовые острова",
		"mask": "+61",
		"length": 9
	},
	"90": {
		"name": "Колумбия",
		"mask": "+57",
		"length": 10
	},
	"91": {
		"name": "Коморы",
		"mask": "+269",
		"length": 7
	},
	"92": {
		"name": "Коста-Рика",
		"mask": "+506",
		"length": 8
	},
	"93": {
		"name": "Кот-д’Ивуар",
		"mask": "+255",
		"length": 8
	},
	"94": {
		"name": "Куба",
		"mask": "+53",
		"length": 8
	},
	"95": {
		"name": "Кувейт",
		"mask": "+965",
		"length": 7
	},
	"96": {
		"name": "Кыргызстан",
		"mask": "+996",
		"length": 9
	},
	"97": {
		"name": "Лаос",
		"mask": "+856",
		"length": 10
	},
	"98": {
		"name": "Лесото",
		"mask": "+266",
		"length": 8
	},
	"99": {
		"name": "Либерия",
		"mask": "+231",
		"length": 7
	},
	"100": {
		"name": "Ливан",
		"mask": "+961",
		"length": 8
	},
	"101": {
		"name": "Ливия",
		"mask": "+218",
		"length": 9
	},
	"102": {
		"name": "Литва",
		"mask": "+218",
		"length": 9
	},
	"103": {
		"name": "Люксембург",
		"mask": "+352",
		"length": 9
	},
	"104": {
		"name": "Маврикий",
		"mask": "+230",
		"length": 7
	},
	"105": {
		"name": "Мавритания",
		"mask": "+222",
		"length": 8
	},
	"106": {
		"name": "Мадагаскар",
		"mask": "+261",
		"length": 9
	},
	"107": {
		"name": "Майотта",
		"mask": "+262",
		"length": 9
	},
	"108": {
		"name": "Малави",
		"mask": "+265",
		"length": 9
	},
	"109": {
		"name": "Малайзия",
		"mask": "+60",
		"length": 9
	},
	"110": {
		"name": "Мали",
		"mask": "+223",
		"length": 8
	},
	"111": {
		"name": "Мальдивы",
		"mask": "+960",
		"length": 7
	},
	"112": {
		"name": "Мальта",
		"mask": "+356",
		"length": 8
	},
	"113": {
		"name": "Марокко",
		"mask": "+212",
		"length": 9
	},
	"114": {
		"name": "Маршалловы Острова",
		"mask": "+692",
		"length": 7
	},
	"115": {
		"name": "Мексика",
		"mask": "+52",
		"length": 11
	},
	"116": {
		"name": "Микронезия",
		"mask": "+691",
		"length": 7
	},
	"117": {
		"name": "Мозамбик",
		"mask": "+258",
		"length": 9
	},
	"118": {
		"name": "Молдавия",
		"mask": "+373",
		"length": 8
	},
	"119": {
		"name": "Монако",
		"mask": "+377",
		"length": 9
	},
	"120": {
		"name": "Монголия",
		"mask": "+976",
		"length": 8
	},
	"121": {
		"name": "Монтсеррат",
		"mask": "+1",
		"length": 10
	},
	"122": {
		"name": "Мьянма",
		"mask": "+95",
		"length": 8
	},
	"123": {
		"name": "Намибия",
		"mask": "+264",
		"length": 9
	},
	"124": {
		"name": "Науру",
		"mask": "+674",
		"length": 7
	},
	"125": {
		"name": "Непал",
		"mask": "+977",
		"length": 10
	},
	"126": {
		"name": "Нигер",
		"mask": "+227",
		"length": 8
	},
	"127": {
		"name": "Нигерия",
		"mask": "+234",
		"length": 10
	},
	"129": {
		"name": "Нидерланды",
		"mask": "+31",
		"length": 9
	},
	"130": {
		"name": "Никарагуа",
		"mask": "+505",
		"length": 8
	},
	"131": {
		"name": "Ниуэ",
		"mask": "+683",
		"length": 4
	},
	"132": {
		"name": "Новая Зеландия",
		"mask": "+64",
		"length": 9
	},
	"133": {
		"name": "Новая Каледония",
		"mask": "+687",
		"length": 6
	},
	"134": {
		"name": "Норвегия",
		"mask": "+47",
		"length": 8
	},
	"135": {
		"name": "ОАЭ",
		"mask": "+971",
		"length": 9
	},
	"136": {
		"name": "Оман",
		"mask": "+968",
		"length": 8
	},
	"138": {
		"name": "Остров Норфолк",
		"mask": "+672",
		"length": 6
	},
	"139": {
		"name": "Остров Рождества",
		"mask": "+61",
		"length": 9
	},
	"141": {
		"name": "Острова Кука",
		"mask": "+682",
		"length": 5
	},
	"143": {
		"name": "Пакистан",
		"mask": "+92",
		"length": 10
	},
	"144": {
		"name": "Палау",
		"mask": "+680",
		"length": 7
	},
	"145": {
		"name": "Папуа - Новая Гвинея",
		"mask": "+675",
		"length": 7
	},
	"146": {
		"name": "Парагвай",
		"mask": "+595",
		"length": 9
	},
	"147": {
		"name": "Перу",
		"mask": "+51",
		"length": 9
	},
	"148": {
		"name": "Польша",
		"mask": "+48",
		"length": 9
	},
	"149": {
		"name": "Португалия",
		"mask": "+351",
		"length": 9
	},
	"150": {
		"name": "Пуэрто-Рико",
		"mask": "+1",
		"length": 10
	},
	"151": {
		"name": "Республика Конго",
		"mask": "+243",
		"length": 9
	},
	"152": {
		"name": "КНДР",
		"mask": "+82",
		"length": 10
	},
	"153": {
		"name": "Республика Македония",
		"mask": "+389",
		"length": 8
	},
	"154": {
		"name": "Россия",
		"mask": "+7",
		"length": 10
	},
	"155": {
		"name": "Руанда",
		"mask": "+250",
		"length": 9
	},
	"156": {
		"name": "Румыния",
		"mask": "+40",
		"length": 9
	},
	"157": {
		"name": "Сальвадор",
		"mask": "+503",
		"length": 8
	},
	"158": {
		"name": "Самоа",
		"mask": "+685",
		"length": 6
	},
	"159": {
		"name": "Сан-Марино",
		"mask": "+378",
		"length": 8
	},
	"160": {
		"name": "Сан-Томе и Принсипи",
		"mask": "+239",
		"length": 7
	},
	"161": {
		"name": "Саудовская Аравия",
		"mask": "+966",
		"length": 9
	},
	"162": {
		"name": "Свазиленд",
		"mask": "+268",
		"length": 8
	},
	"163": {
		"name": "Северные Марианские острова",
		"mask": "+1",
		"length": 10
	},
	"164": {
		"name": "Сейшельские Острова",
		"mask": "+248",
		"length": 7
	},
	"165": {
		"name": "Сен-Пьер и Микелон",
		"mask": "+508",
		"length": 6
	},
	"166": {
		"name": "Сенегал",
		"mask": "+221",
		"length": 9
	},
	"167": {
		"name": "Сент-Винсент и Гренадины",
		"mask": "+1",
		"length": 10
	},
	"168": {
		"name": "Сент-Китс и Невис",
		"mask": "+1",
		"length": 10
	},
	"169": {
		"name": "Сент-Люсия",
		"mask": "+1",
		"length": 10
	},
	"170": {
		"name": "Сербия",
		"mask": "+381",
		"length": 9
	},
	"171": {
		"name": "Сингапур",
		"mask": "+65",
		"length": 8
	},
	"172": {
		"name": "Сирия",
		"mask": "+963",
		"length": 9
	},
	"173": {
		"name": "Словакия",
		"mask": "+421",
		"length": 9
	},
	"174": {
		"name": "Словения",
		"mask": "+386",
		"length": 8
	},
	"175": {
		"name": "Соломоновы Острова",
		"mask": "+677",
		"length": 7
	},
	"176": {
		"name": "Сомали",
		"mask": "+252",
		"length": 8
	},
	"177": {
		"name": "Судан",
		"mask": "+249",
		"length": 9
	},
	"178": {
		"name": "Суринам",
		"mask": "+597",
		"length": 7
	},
	"179": {
		"name": "Сьерра-Леоне",
		"mask": "+232",
		"length": 8
	},
	"180": {
		"name": "Таджикистан",
		"mask": "+992",
		"length": 9
	},
	"181": {
		"name": "Таиланд",
		"mask": "+66",
		"length": 9
	},
	"182": {
		"name": "Танзания",
		"mask": "+255",
		"length": 9
	},
	"183": {
		"name": "Тёркс и Кайкос",
		"mask": "+1",
		"length": 10
	},
	"184": {
		"name": "Того",
		"mask": "+228",
		"length": 8
	},
	"185": {
		"name": "Токелау",
		"mask": "+676",
		"length": 7
	},
	"186": {
		"name": "Тонга",
		"mask": "+676",
		"length": 7
	},
	"187": {
		"name": "Тринидад и Тобаго",
		"mask": "+1",
		"length": 10
	},
	"188": {
		"name": "Тувалу",
		"mask": "+688",
		"length": 6
	},
	"189": {
		"name": "Тунис",
		"mask": "+216",
		"length": 8
	},
	"190": {
		"name": "Туркмения",
		"mask": "+993",
		"length": 8
	},
	"191": {
		"name": "Уганда",
		"mask": "+256",
		"length": 9
	},
	"192": {
		"name": "Узбекистан",
		"mask": "+998",
		"length": 9
	},
	"193": {
		"name": "Украина",
		"mask": "+380",
		"length": 9
	},
	"194": {
		"name": "Уоллис и Футуна",
		"mask": "+681",
		"length": 6
	},
	"195": {
		"name": "Уругвай",
		"mask": "+598",
		"length": 8
	},
	"196": {
		"name": "Фарерские острова",
		"mask": "+298",
		"length": 6
	},
	"197": {
		"name": "Фиджи",
		"mask": "+679",
		"length": 7
	},
	"198": {
		"name": "Филиппины",
		"mask": "+63",
		"length": 10
	},
	"199": {
		"name": "Финляндия",
		"mask": "+358",
		"length": 9
	},
	"200": {
		"name": "Фолклендские острова",
		"mask": "+500",
		"length": 5
	},
	"201": {
		"name": "Французская Полинезия",
		"mask": "+689",
		"length": 9
	},
	"203": {
		"name": "ЦАР",
		"mask": "+236",
		"length": 8
	},
	"204": {
		"name": "Чад",
		"mask": "+235",
		"length": 8
	},
	"205": {
		"name": "Черногория",
		"mask": "+382",
		"length": 8
	},
	"206": {
		"name": "Чехия",
		"mask": "+420",
		"length": 9
	},
	"207": {
		"name": "Чили",
		"mask": "+56",
		"length": 9
	},
	"208": {
		"name": "Швеция",
		"mask": "+46",
		"length": 9
	},
	"209": {
		"name": "Шпицберген и Ян-Майен",
		"mask": "+47",
		"length": 8
	},
	"210": {
		"name": "Шри-Ланка",
		"mask": "+94",
		"length": 9
	},
	"211": {
		"name": "Эквадор",
		"mask": "+593",
		"length": 9
	},
	"212": {
		"name": "Экваториальная Гвинея",
		"mask": "+240",
		"length": 9
	},
	"213": {
		"name": "Эритрея",
		"mask": "+291",
		"length": 7
	},
	"214": {
		"name": "Эстония",
		"mask": "+372",
		"length": 8
	},
	"216": {
		"name": "ЮАР",
		"mask": "+27",
		"length": 9
	},
	"218": {
		"name": "Ямайка",
		"mask": "+1",
		"length": 10
	},
	"219": {
		"name": "Япония",
		"mask": "+81",
		"length": 10
	}
};


//////////////////
// WEBPACK FOOTER
// ./js/shared/dictionaries/availableCountries/ru.json
// module id = 650
// module chunks = 2 3